// extracted by mini-css-extract-plugin
module.exports = {"freeSpins":"_8118f1e","moreInfoBtn":"_89ca260","centered":"_80c511b"};